<template>
  <div id="registerPage" class="register">
    <div class="register-left">
      <h1 class="tit">{{ leftData.tit }}</h1>
      <p class="con">{{ leftData.con }}</p>
      <div class="img-con">
        <img src="../assets/imgs/james-signup.png" alt />
      </div>
      <ul class="left-list">
        <li v-for="(item, index) in leftData.leftList" :key="index">
          <div class="left-item">
            <span class="circle-true"></span>
          </div>
          <div class="right-item">
            <p class="tit">{{ item.tit }}</p>
            <p class="con">{{ item.con }}</p>
          </div>
        </li>
      </ul>
    </div>
    <!-- 注册表单 -->
    <div class="register-right">
      <h1 class="tit">Try WIDI for free</h1>
      <p class="con">One free token would be given for you to have a perfect experience in Widi.</p>
      <form class="form_post" method="post">
        <div class="form-item">
          <label for="firm-name">Practice unit name</label>
          <el-input id="firm-name" v-model="firmName" ></el-input>
        </div>
        <!-- 国家 -->
        <div class="form-item">
          <label for="country">Country</label>
          <el-select v-model="countryValue" filterable placeholder="Select" v-loading="country_loading">
            <el-option v-for="item in country_data" :key="item.id" :label="item.country" :value="item.id">
              <span style="float: left">{{ item.country }}</span>
              <div class="opt-img-box">
                <img style="vertical-align: middle;" :src="item.flag" alt />
              </div>
            </el-option>
          </el-select>
        </div>
        <!-- 工作 -->
        <div class="form-item">
          <label for="job-title">Job Title</label>
          <el-select v-model="jobValue" placeholder=" ">
            <el-option v-for="(item, index) in jobData" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </div>
        <!-- 姓 -->
        <div class="form-item">
          <label for="first-name">First Name</label>
          <el-input id="first-name" v-model="firstName"></el-input>
        </div>
        <!-- 名 -->
        <div class="form-item">
          <label for="last-name">Last Name</label>
          <el-input id="last-name" v-model="lastName"></el-input>
        </div>
        <!-- 邮箱 -->
        <div class="form-item">
          <label for="email">Email</label>
          <el-input id="email" v-model="email"></el-input>
        </div>
        <div class="more-box">
          <div class="more-item">
            <el-checkbox v-model="subscribe"></el-checkbox>
            <div>
              <p class="con">
                Please send me tips, news, special offers of Widi’s services and products!
                <router-link tag="a" target="_blank" :to="{ path: '/PrivacyTerms', query: { name: 'privacy',anchor:'privacy_sec_point' } }">More details</router-link>
              </p>
            </div>
          </div>
          <div class="more-item">
            <p class="con">
              By clicking Join Us, you agree to
              <router-link tag="a" target="_blank" to="/PrivacyTerms?name=terms">User’s Agreement</router-link>
              and
              <router-link tag="a" target="_blank" to="/PrivacyTerms?name=privacy">Privacy Statement.</router-link>
            </p>
          </div>
        </div>
        <!-- 注册按钮 -->
        <el-button @click="Register" v-loading="btn_loading" element-loading-spinner="el-icon-loading" element-loading-custom-class="btn-loading" :disabled="btn_loading" class="register-btn">JOIN US</el-button>
      </form>
      <div class="dots"></div>
    </div>
  </div>
</template>

<script>
import { Register, getAreaCodeApi } from "../api/register.js";
export default {
  name: "Register",
  props: {
    country_data: {
      type: Array
    },
    country_loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      leftData: {
        tit: "Let WIDI be your diligent partner",
        con: "It's time to embrace the digital transformation.",
        leftList: [
          // {
          //   tit: "Cloud-based solution",
          //   con:
          //     "Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. Aenean dignissim pellentesque felis.",
          // },
          // {
          //   tit: "Cloud-based solution",
          //   con:
          //     "Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. Aenean dignissim pellentesque felis.",
          // },
          // {
          //   tit: "Cloud-based solution",
          //   con:
          //     "Donec nec justo eget felis facilisis fermentum. Aliquam porttitor mauris sit amet orci. Aenean dignissim pellentesque felis.",
          // },
        ]
      },
      // 国家数据
      // countryData: JSON.parse(localStorage.getItem('country_data')),
      // 工作选项
      jobData: [
        {
          name: "Owner"
        },
        {
          name: "Partner"
        },
        {
          name: "Director"
        },
        {
          name: "Manager"
        },
        {
          name: "Audit staff"
        },
        {
          name: "Others"
        }
      ],
      firmName: "",
      countryValue: "",
      jobValue: "",
      firstName: "",
      lastName: "",
      email: "",
      subscribe: false,
      btn_loading: false
    };
  },
  methods: {
    // 注册
    Register () {
      // 非空验证
      if (
        this.firmName.trim().length === 0 ||
        this.firstName.trim().length === 0 ||
        this.lastName.trim().length === 0 ||
        this.email.trim().length === 0 ||
        this.jobValue === ""
      ) {
        this.$message.error("A required item is not filled in");
        return;
      }
      // 验证邮箱
      // var regEmail = /^[A-Za-z0-9_\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      // if (!regEmail.test(this.email)) {
      //   this.$message.error("Please check your email");
      //   return;
      // }
      this.btn_loading = true;
      var data = {
        agent_name: this.firmName,
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email,
        subscribe: this.subscribe,
        country_id: this.countryValue,
      };
      if(this.$route.query.invite){
        data.invite_by = this.$route.query.invite
      }
      Register(data)
        .then(res => {
          if (res.result === "success") {
            this.$message({
              message: "Registration succeed.",
              type: "success",
              customClass: "message"
            });
            this.$router.push({ path: '/Home' })
          } else {
            this.$message.error("Registration failed. Please try again later");
          }
          this.btn_loading = false;
        })
        .catch(err => {
          this.btn_loading = false;
          let msg = ''
          for (const key in err.response.data.error.errors) {
            msg += '<p style="line-height: 1.3;">' + err.response.data.error.errors[key] + '</p>'
          }
          this.$message({
            dangerouslyUseHTMLString: true,
            message: msg,
            type: 'error',
            duration: 5 * 1000
          })
        });
    }
  }
};
</script>

<style scoped lang="scss">
.register {
  max-width: 940px;
  margin: 0 auto;
  padding-top: 90px;
  display: flex;
  .register-left {
    width: 39%;
    padding: 60px 10px;
    text-align: center;
    box-sizing: border-box;
    margin-right: 20px;
    .tit {
      font-size: 36px;
    }
    .con {
      margin: 30px auto;
      text-align: center;
      width: 55%;
      color: rgba(35, 31, 32, 0.8);
    }
    .left-list {
      width: 65%;
      & > li {
        display: flex;
        height: 70px;
        overflow: hidden;
        margin-bottom: 15px;
      }
      .left-item {
        .circle-true {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background: #23bd8b;
          display: block;
          position: relative;
        }
        .circle-true:before,
        .circle-true::after {
          content: "";
          height: 10px;
          width: 2px;
          border-radius: 10px;
          display: block;
          background: white;
          position: absolute;
          top: 5px;
          left: 10px;
          transform: rotate(45deg);
          -ms-transform: rotate(45deg);
        }
        .circle-true::before {
          height: 7px;
          width: 2px;
          transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          position: absolute;
          top: 8px;
          left: 5px;
        }
      }
      .right-item {
        padding-left: 15px;
        .tit {
          font-size: 18px;
          font-weight: 600;
          color: rgba(35, 31, 32, 1);
        }
        .con {
          font-size: 18px;
          font-weight: 400;
          color: rgba(35, 31, 32, 1);
          line-height: 24px;
          opacity: 0.8;
          margin: 0;
        }
      }
    }
  }
  .register-right {
    padding: 60px;
    box-sizing: border-box;
    color: rgba(255, 255, 255, 0.8);
    background: #23bd8b;
    width: 58%;
    position: relative;
    .tit {
      color: white;
      font-size: 36px;
    }
    .con {
      font-size: 16px;
      line-height: 24px;
      padding: 22px 0 16px;
    }
    .form_post {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .form-item {
        width: 100%;
        margin-bottom: 10px;
        position: relative;
        & > label {
          font-size: 14px;
          line-height: 50px;
          cursor: pointer;
        }
        .el-select {
          width: 100%;
        }
      }
      .form-item:nth-child(4),
      .form-item:nth-child(5) {
        width: 45%;
      }
      .more-box {
        .more-item {
          display: flex;
          margin-bottom: 29px;
          .con {
            line-height: 18px;
            padding: 0;
            font-size: 14px;
          }
          &:first-child {
            margin: 20px 0 17px;
            .con {
              padding-left: 9px;
            }
          }
        }
      }
      .register-btn {
        width: 100%;
        line-height: 50px;
        background: #231f20;
        font-size: 15px;
        padding: 0;
        border: 0;
        color: white !important;
        font-family: "Medium";
      }
    }
    .dots {
      height: 170px;
      width: 65px;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAACqCAYAAADydCIEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjEwQjZGQjdBQjBBMTFFQThBRUNGMDM0ODgyRTM1QUUiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjEwQjZGQjhBQjBBMTFFQThBRUNGMDM0ODgyRTM1QUUiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCMTBCNkZCNUFCMEExMUVBOEFFQ0YwMzQ4ODJFMzVBRSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCMTBCNkZCNkFCMEExMUVBOEFFQ0YwMzQ4ODJFMzVBRSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgyxwCMAAAGVSURBVHja7NkxrgFRFIDhS6OxBvtQSuzDJCzLSlCosA61gohG5UwyhSjkyoRkru8m9/FenCm+RE7+vN7pfBmllJZxx3H3cRdxjynvFDHbC4R1vJk+fWgbd5L5wCJma4RrvBk+/fEed5D5wCJm+/Hj8PKhXco/RczWCPO4m7i35rX64IFFzNZfh/TvBwIECBAgQIAAAcKb02/SctWExar5PfcUMSulpbSUltJS2oqEAAECBAgQIECQ0lJaSktpKS2lrUgIECBAgAABAgQpLaWltJSW0lLaioQAAQIECBAgQJDSUlpKS2kpLaWtSAgQIECAAAECBCktpaW0lC4upWctsrSTs7aDFQkBAgQIECBAgCClpbSUltJSWkpbkRAgQIAAAQIECFJaSktpKf3DlK5aZGknZ20HKxICBAgQIECAAEFKS2kpLaXbpbT/SluRECBAgAABAgQIEKS0lJbSUlpKS2krEgIECBAgQIAAQUpLaSktpb+X0lWLLO3krO1gRUKAAAECBAgQIEhpKS2lpbSU/mj2IcAASygjXDuEzSMAAAAASUVORK5CYII=)
        no-repeat;
      position: absolute;
      right: -30px;
      top: -32px;
      z-index: -1;
    }
  }
}
@media screen and (max-width: 768px) {
  .register {
    flex-wrap: wrap;
    padding: 20px;
    .register-left {
      width: 100%;
      padding: 0;
      margin-bottom: 20px;
      .tit {
        font-size: 36px;
      }
      .img-con {
        text-align: center;
        & > img {
          width: 50%;
        }
      }
      .left-list {
        width: 70%;
      }
    }
    .register-right {
      padding: 60px 20px;
      width: auto;
      .form_post {
        .form-item:nth-child(4),
        .form-item:nth-child(5) {
          width: 100%;
        }
      }
      .dots {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
#registerPage .el-checkbox__inner {
  width: 20px;
  height: 20px;
  &::after {
    left: 7px;
    top: 3px;
  }
}
</style>